import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useSelector } from "react-redux";
import { AdminStatusCssClasses } from "../AdminsUIHelpers";
import { useAdminsUIContext } from "../AdminsUIContext";

const selectedAdmins = (entities, ids) => {
  const _admins = [];
  ids.forEach((id) => {
    const admin = entities.find((el) => el.id === id);
    if (admin) {
      _admins.push(admin);
    }
  });
  return _admins;
};

export function AdminsFetchDialog({ show, onHide }) {
  // Admins UI Context
  const adminsUIContext = useAdminsUIContext();
  const adminsUIProps = useMemo(() => {
    return {
      ids: adminsUIContext.ids,
      queryParams: adminsUIContext.queryParams,
    };
  }, [adminsUIContext]);

  // Admins Redux state
  const { admins } = useSelector(
    (state) => ({
      admins: selectedAdmins(state.admins.entities, adminsUIProps.ids),
    }),
    shallowEqual
  );

  // if there weren't selected ids we should close modal
  useEffect(() => {
    if (!adminsUIProps.ids || adminsUIProps.ids.length === 0) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminsUIProps.ids]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Fetch selected elements
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="list-timeline list-timeline-skin-light padding-30">
          <div className="list-timeline-items">
            {admins.map((admin) => (
              <div className="list-timeline-item mb-3" key={admin.id}>
                <span className="list-timeline-text">
                  <span
                    className={`label label-lg label-light-${
                      AdminStatusCssClasses[admin.status]
                    } label-inline`}
                    
                  >
                    ID: {admin.id}
                  </span>{" "}
                  <span className={`label label-lg label-light-${
                      AdminStatusCssClasses[admin.status]
                    } label-inline`}>
                    name : {admin.name}
                  </span>
                </span>
              </div>
            ))}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-primary btn-elevate"
          >
            Ok
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
